var map = {
	"./CASTiT.png": "747d",
	"./CoreGuide.png": "a974",
	"./amenity/g0001.png": "4f1f",
	"./amenity/g0002.png": "3b8dd",
	"./amenity/g0003.png": "a98f",
	"./amenity/g0004.png": "a317",
	"./amenity/g0005.png": "e58e",
	"./amenity/g0006.png": "bdbe",
	"./amenity/g0007.png": "0700",
	"./amenity/g0008.png": "85c2",
	"./amenity/g0010.png": "0d6d",
	"./amenity/g0011.png": "ccf4",
	"./amenity/g0012.png": "b1a9",
	"./amenity/g0013.png": "94bd",
	"./amenity/g0014.png": "a0c2",
	"./amenity/g0015.png": "a693",
	"./amenity/g0016.png": "5737",
	"./amenity/g0017.png": "ae8b",
	"./amenity/g0018.png": "de8e",
	"./amenity/g0019.png": "1f83",
	"./amenity/g0020.png": "5085",
	"./amenity/g0021.png": "0208",
	"./amenity/g0022.png": "057a",
	"./amenity/g0023.png": "e90a",
	"./amenity/g0024.png": "2361",
	"./amenity/g0025.png": "9719",
	"./amenity/g0026.png": "9258",
	"./amenity/g0027.png": "817a",
	"./amenity/g0028.png": "640f",
	"./amenity/g0029.png": "8d54",
	"./amenity/g0030.png": "b230",
	"./amenity/g0031.png": "72e4",
	"./amenity/g0032.png": "3bd6",
	"./amenity/g0033.png": "c9cf",
	"./amenity/g0034.png": "b3fa",
	"./amenity/g0035.png": "52b5",
	"./amenity/g0036.png": "305d",
	"./amenity/g0037.png": "9785",
	"./amenity/g0038.png": "1f74",
	"./amenity/g0039.png": "8d27",
	"./amenity/g0040.png": "902e",
	"./amenity/g0041.png": "dda7",
	"./amenity/g0042.png": "4a94",
	"./amenity/g0043.png": "1687",
	"./amenity/g0044.png": "baf2",
	"./amenity/g0045.png": "ee95",
	"./amenity/g0046.png": "5185",
	"./amenity/g0047.png": "68af",
	"./amenity/g0048.png": "6581",
	"./amenity/g0049.png": "d0db",
	"./amenity/g0050.png": "f807",
	"./amenity/g0051.png": "4ad0",
	"./amenity/g0052.png": "a11c",
	"./amenity/g0053.png": "e6fd",
	"./amenity/g0054.png": "5b2c",
	"./amenity/g0055.png": "a03d",
	"./amenity/g0056.png": "4616",
	"./amenity/g0057.png": "4e65",
	"./amenity/g0058.png": "372d",
	"./amenity/g0059.png": "3167",
	"./amenity/g0060.png": "0003",
	"./amenity/g0061.png": "af98",
	"./amenity/g0062.png": "ef94",
	"./amenity/g0063.png": "0ecd",
	"./amenity/g0064.png": "85d3",
	"./amenity/g0065.png": "8520",
	"./amenity/g0066.png": "725b",
	"./amenity/g0067.png": "c729",
	"./amenity/g0068.png": "4259",
	"./amenity/g0100.png": "4ed6",
	"./amenity/g0101.png": "1cd8",
	"./amenity/g0102.png": "e787",
	"./amenity/g0103.png": "46b1",
	"./amenity/g0104.png": "c7c3",
	"./amenity/g0105.png": "07fb",
	"./amenity/g0106.png": "1a04",
	"./amenity/g0107.png": "df43",
	"./amenity/g0108.png": "95f0",
	"./amenity/g0109.png": "977c",
	"./amenity/g0111.png": "ca6b",
	"./amenity/g0112.png": "2210",
	"./amenity/g0113.png": "c16f",
	"./amenity/g0114.png": "c834",
	"./amenity/g0115.png": "d321",
	"./amenity/g0116.png": "f788",
	"./amenity/g0117.png": "40f9",
	"./amenity/g0118.png": "f781",
	"./amenity/g0119.png": "a2c3",
	"./amenity/g0120.png": "3648",
	"./amenity/g0121.png": "2905",
	"./amenity/g0122.png": "b0a3",
	"./amenity/g0123.png": "24db",
	"./amenity/g0124.png": "f0cd",
	"./amenity/g0125.png": "ec1e",
	"./amenity/g0126.png": "f696",
	"./amenity/g0127.png": "34c8",
	"./amenity/g0128.png": "b2e0",
	"./amenity/g0129.png": "9d3b",
	"./amenity/g0130.png": "619f",
	"./amenity/g0131.png": "6c4a",
	"./amenity/g0132.png": "1045",
	"./amenity/g0133.png": "3fdb",
	"./amenity/g0134.png": "30c3",
	"./amenity/g0136.png": "a160",
	"./amenity/g0137.png": "2881",
	"./amenity/g0138.png": "6319",
	"./amenity/g0139.png": "1262",
	"./amenity/g0140.png": "a4816",
	"./amenity/g0141.png": "37e4",
	"./amenity/g0142.png": "9a6d",
	"./amenity/g0143.png": "a505",
	"./amenity/g0144.png": "1912",
	"./amenity/g0145.png": "744f",
	"./amenity/g0146.png": "52c6",
	"./amenity/g0147.png": "af9b",
	"./amenity/g0148.png": "da6e",
	"./amenity/g0149.png": "184a",
	"./amenity/g0150.png": "925d",
	"./amenity/g0151.png": "f140",
	"./amenity/g0152.png": "c790",
	"./amenity/g0153.png": "e7b2",
	"./amenity/g0154.png": "0c5e",
	"./amenity/g0155.png": "005c",
	"./amenity/g0156.png": "5d90",
	"./amenity/g0157.png": "6754",
	"./amenity/g0158.png": "22b4",
	"./amenity/g0159.png": "52c0",
	"./amenity/g0160.png": "2164",
	"./amenity/g0161.png": "4f92",
	"./amenity/g0162.png": "b008",
	"./amenity/g0163.png": "cc21",
	"./amenity/g0164.png": "551d",
	"./amenity/g0165.png": "ca5b",
	"./amenity/g0166.png": "f18e",
	"./amenity/g0167.png": "e550",
	"./amenity/g0168.png": "a719",
	"./amenity/g0169.png": "3d8c",
	"./amenity/g0170.png": "88f2",
	"./amenity/g0171.png": "1ee8",
	"./amenity/g0172.png": "8c84",
	"./amenity/g0173.png": "3ed7",
	"./amenity/g0174.png": "0393",
	"./amenity/g0175.png": "4e36",
	"./amenity/g0176.png": "a8c3",
	"./amenity/g0200.png": "07fe",
	"./amenity/g0201.png": "1748",
	"./amenity/g0202.png": "191e",
	"./amenity/g0203.png": "59e9",
	"./amenity/g0204.png": "408a",
	"./amenity/g0205.png": "7f76",
	"./amenity/g0206.png": "50b1",
	"./amenity/g0207.png": "441a",
	"./amenity/g0208.png": "d18e",
	"./amenity/g0209.png": "c8d2",
	"./amenity/g0210.png": "0edc",
	"./amenity/g0211.png": "c831",
	"./amenity/g0212.png": "d070",
	"./amenity/g0213.png": "e49b",
	"./amenity/g0214.png": "b41d",
	"./amenity/g0215.png": "bed7",
	"./amenity/g0216.png": "6b6b",
	"./amenity/g0217.png": "c11d",
	"./amenity/g0218.png": "6283",
	"./amenity/g0219.png": "485e",
	"./amenity/g0220.png": "40f8",
	"./amenity/g0221.png": "97fc",
	"./amenity/g0222.png": "30af",
	"./amenity/g0223.png": "9050",
	"./amenity/g0224.png": "7d4c",
	"./amenity/g0225.png": "d0f7",
	"./amenity/g0226.png": "54d8",
	"./amenity/g0227.png": "1d4e",
	"./amenity/g0228.png": "5abc",
	"./amenity/g0229.png": "6b3a",
	"./amenity/g0230.png": "659d",
	"./amenity/g0231.png": "c000",
	"./amenity/g0232.png": "93ee",
	"./amenity/g0233.png": "88d5",
	"./amenity/g0234.png": "6f01",
	"./amenity/g0235.png": "967f",
	"./amenity/g0236.png": "2264",
	"./amenity/g0237.png": "b2d8",
	"./amenity/g0238.png": "3d1e",
	"./amenity/g0239.png": "3133",
	"./amenity/g0240.png": "afdd",
	"./amenity/g0241.png": "373e",
	"./amenity/g0242.png": "6383",
	"./amenity/g0243.png": "6271",
	"./amenity/g0244.png": "7034",
	"./amenity/g0245.png": "ff30",
	"./amenity/g0246.png": "1288",
	"./amenity/g0247.png": "e44f",
	"./amenity/g0248.png": "7167",
	"./amenity/g0249.png": "32d8",
	"./amenity/g0250.png": "7104",
	"./amenity/g0251.png": "8fbb",
	"./amenity/g0252.png": "63831",
	"./amenity/g0253.png": "7d35",
	"./amenity/g0254.png": "95be",
	"./amenity/g0255.png": "3276",
	"./amenity/g0256.png": "d8ff",
	"./amenity/g0257.png": "8886",
	"./amenity/g0258.png": "0471",
	"./amenity/g0259.png": "0144",
	"./amenity/g0260.png": "b303",
	"./amenity/g0261.png": "0583",
	"./amenity/g0262.png": "257b",
	"./amenity/g0263.png": "6c1b",
	"./amenity/g0264.png": "42fa",
	"./amenity/g0265.png": "b3ab",
	"./amenity/g0266.png": "2b72",
	"./amenity/g0267.png": "42ba",
	"./amenity/g0268.png": "2314",
	"./amenity/t0001.png": "1cac",
	"./banner_back.png": "56c9",
	"./banner_localinfo.png": "faa3",
	"./bg_img_placeholder.jpg": "9585",
	"./bg_instagram_feed.png": "bedd",
	"./bookmark.png": "e3d3",
	"./btn_destination_input.png": "a676",
	"./btn_destination_map.png": "d993",
	"./btn_destination_preset.png": "2de2",
	"./btn_international_pay.png": "287c",
	"./btn_normal_pay.png": "4585",
	"./btn_pg_alipay.png": "345a",
	"./btn_pg_paypal.png": "c607",
	"./btn_pg_wechatpay.png": "acc1",
	"./check_wh.png": "1810",
	"./chevron-right.png": "f18f",
	"./complete.png": "0b3e",
	"./country/af.svg": "9e50",
	"./country/ar.svg": "d42c",
	"./country/cs.svg": "39ce",
	"./country/da.svg": "8af9",
	"./country/de.svg": "d08c",
	"./country/el.svg": "0237",
	"./country/en.svg": "8166",
	"./country/es.svg": "e6b5",
	"./country/fi.svg": "152d",
	"./country/fr.svg": "0977",
	"./country/hi.svg": "1925",
	"./country/id.svg": "aada",
	"./country/it.svg": "72bc",
	"./country/ja.svg": "54bc",
	"./country/kk.svg": "f172",
	"./country/ko.svg": "2ad7",
	"./country/mm.svg": "f401",
	"./country/ms.svg": "7bc6",
	"./country/nl.svg": "86bf",
	"./country/no.svg": "ea2a",
	"./country/pl.svg": "3e49",
	"./country/pt.svg": "d5e0",
	"./country/ru.svg": "105b",
	"./country/sv.svg": "35ef",
	"./country/th.svg": "7fe2",
	"./country/tl.svg": "71b9",
	"./country/tr.svg": "f188",
	"./country/uk.svg": "f69a",
	"./country/vi.svg": "4c03",
	"./country/zh-CN.svg": "1d74",
	"./country/zh-TW.svg": "f2c9",
	"./countryall/001-mauritius.svg": "d713",
	"./countryall/003-austria.svg": "1504",
	"./countryall/004-oman.svg": "3ba3",
	"./countryall/005-ethiopia.svg": "f7ae",
	"./countryall/006-tanzania.svg": "a019",
	"./countryall/007-nicaragua.svg": "3273",
	"./countryall/008-estonia.svg": "4406",
	"./countryall/009-uganda.svg": "8135",
	"./countryall/010-slovenia.svg": "ca51",
	"./countryall/011-zimbabwe.svg": "51a1",
	"./countryall/012-sao-tome-and-prince.svg": "579f",
	"./countryall/013-italy.svg": "ac53",
	"./countryall/014-wales.svg": "ff5d",
	"./countryall/015-el-salvador.svg": "c9c6",
	"./countryall/016-nepal.svg": "20c0",
	"./countryall/017-christmas-island.svg": "a6f3",
	"./countryall/018-lebanon.svg": "1242",
	"./countryall/019-ceuta.svg": "c802",
	"./countryall/020-iraq.svg": "3db5",
	"./countryall/021-cook-islands.svg": "346d",
	"./countryall/022-syria.svg": "d769",
	"./countryall/023-cocos-island.svg": "e184",
	"./countryall/024-honduras.svg": "30ce",
	"./countryall/025-anguilla.svg": "e032",
	"./countryall/026-qatar.svg": "6d29",
	"./countryall/027-american-samoa.svg": "046f",
	"./countryall/028-puerto-rico.svg": "21cd",
	"./countryall/029-comoros.svg": "3814",
	"./countryall/030-north-korea.svg": "14cd",
	"./countryall/031-corsica.svg": "171a",
	"./countryall/032-zambia.svg": "5ccc",
	"./countryall/033-saint-kitts-and-nevis.svg": "38bf",
	"./countryall/034-china.svg": "f561",
	"./countryall/035-luxembourg.svg": "c297",
	"./countryall/036-central-african-republic.svg": "939b",
	"./countryall/037-jamaica.svg": "55ca",
	"./countryall/038-cape-verde.svg": "a120",
	"./countryall/039-monaco.svg": "1932",
	"./countryall/040-bhutan.svg": "d453",
	"./countryall/041-paraguay.svg": "144b",
	"./countryall/042-aruba.svg": "f1bf",
	"./countryall/043-montserrat.svg": "4ad3",
	"./countryall/044-latvia.svg": "7a79",
	"./countryall/045-andorra.svg": "56f3",
	"./countryall/046-micronesia.svg": "81af",
	"./countryall/047-dominican-republic.svg": "858d",
	"./countryall/048-abkhazia.svg": "8808",
	"./countryall/049-tunisia.svg": "96b3",
	"./countryall/050-mauritania.svg": "5ba4",
	"./countryall/051-cayman-islands.svg": "5f46",
	"./countryall/052-kosovo.svg": "0d50",
	"./countryall/053-ghana.svg": "67f0",
	"./countryall/054-canary-islands.svg": "274b",
	"./countryall/055-scotland.svg": "6fcb",
	"./countryall/056-guinea-bissau.svg": "ac1a",
	"./countryall/057-burundi.svg": "77a2",
	"./countryall/058-myanmar.svg": "d3dc",
	"./countryall/059-gabon.svg": "bd9e",
	"./countryall/060-benin.svg": "68a4",
	"./countryall/061-saba-island.svg": "45df",
	"./countryall/062-namibia.svg": "646c",
	"./countryall/063-japan.svg": "fa9c",
	"./countryall/064-lithuania.svg": "c6a9",
	"./countryall/065-eritrea.svg": "f121",
	"./countryall/066-chad.svg": "d51f",
	"./countryall/067-kenya.svg": "e710",
	"./countryall/068-djibouti.svg": "4d6e",
	"./countryall/069-british-indian-ocean-territory.svg": "d67b",
	"./countryall/070-tuvalu-1.svg": "14d0",
	"./countryall/071-serbia.svg": "3880",
	"./countryall/072-bonaire.svg": "0b98",
	"./countryall/073-togo.svg": "3738",
	"./countryall/074-kazakhstan.svg": "4894",
	"./countryall/075-antigua-and-barbuda.svg": "9d9a",
	"./countryall/076-suriname.svg": "764d",
	"./countryall/077-jordan.svg": "eed3",
	"./countryall/078-belize.svg": "8167",
	"./countryall/079-st-barts.svg": "1677",
	"./countryall/080-iceland.svg": "389e",
	"./countryall/081-bermuda.svg": "72c6",
	"./countryall/082-united-nations.svg": "cfd9",
	"./countryall/083-somalia.svg": "b39e",
	"./countryall/084-barbados.svg": "5c67",
	"./countryall/085-solomon-islands.svg": "066a",
	"./countryall/086-nigeria.svg": "7bc1",
	"./countryall/087-aland-islands.svg": "7f65",
	"./countryall/088-uruguay.svg": "8e1b",
	"./countryall/089-sint-maarten.svg": "141b",
	"./countryall/090-burkina-faso.svg": "6679",
	"./countryall/091-slovakia.svg": "2156",
	"./countryall/092-sierra-leone.svg": "4f22",
	"./countryall/093-basque-country.svg": "4467",
	"./countryall/094-south-korea.svg": "e764",
	"./countryall/095-pitcairn-islands.svg": "9ce0",
	"./countryall/096-mozambique.svg": "8fa5",
	"./countryall/097-san-marino.svg": "3d0e",
	"./countryall/098-guatemala.svg": "fcfb",
	"./countryall/099-albania.svg": "16f9",
	"./countryall/100-pakistan.svg": "1eb8",
	"./countryall/101-northern-cyprus.svg": "30548",
	"./countryall/102-balearic-islands.svg": "48b6",
	"./countryall/103-marshall-island.svg": "7127",
	"./countryall/104-ecuador.svg": "3673",
	"./countryall/105-cameroon.svg": "4b13",
	"./countryall/106-panama.svg": "f8a7",
	"./countryall/107-kwait.svg": "2b5d",
	"./countryall/108-armenia.svg": "a9db",
	"./countryall/109-romania.svg": "158e",
	"./countryall/110-guinea.svg": "7eb8",
	"./countryall/111-afghanistan.svg": "a4f6",
	"./countryall/112-laos.svg": "8277",
	"./countryall/113-greenland.svg": "8c95",
	"./countryall/114-british-virgin-islands.svg": "2720",
	"./countryall/115-hungary.svg": "08c0",
	"./countryall/116-curacao.svg": "dd16",
	"./countryall/117-angola.svg": "4faa",
	"./countryall/118-malasya.svg": "2ed7",
	"./countryall/119-brunei.svg": "0b8b",
	"./countryall/120-bahamas.svg": "6212",
	"./countryall/121-new-zealand.svg": "831b",
	"./countryall/123-british-columbia.svg": "afab",
	"./countryall/124-vatican-city.svg": "b9b3",
	"./countryall/125-finland.svg": "e0a2",
	"./countryall/126-botswana.svg": "84e3",
	"./countryall/127-sri-lanka.svg": "6732",
	"./countryall/128-spain.svg": "dd5c",
	"./countryall/129-ossetia.svg": "49a7",
	"./countryall/130-sicily.svg": "e758",
	"./countryall/131-chile.svg": "80bd",
	"./countryall/132-bosnia-and-herzegovina.svg": "5b44",
	"./countryall/133-saudi-arabia.svg": "03a5",
	"./countryall/134-liechtenstein.svg": "e2d0",
	"./countryall/135-belarus.svg": "581c",
	"./countryall/136-iran.svg": "d907",
	"./countryall/137-fiji.svg": "7fde",
	"./countryall/138-bahrain.svg": "e8fc",
	"./countryall/139-venezuela.svg": "1850",
	"./countryall/140-east-timor.svg": "a376",
	"./countryall/141-azerbaijan.svg": "4190",
	"./countryall/142-tibet.svg": "d37e",
	"./countryall/143-norway.svg": "433b",
	"./countryall/144-algeria.svg": "5a3e",
	"./countryall/145-ukraine.svg": "f244",
	"./countryall/146-gambia.svg": "22d3",
	"./countryall/147-bangladesh.svg": "da25",
	"./countryall/148-madeira.svg": "c7bd",
	"./countryall/149-czech-republic.svg": "d3de",
	"./countryall/150-bolivia.svg": "a329",
	"./countryall/151-united-arab-emirates.svg": "3cd3",
	"./countryall/152-kyrgyzstan.svg": "f53b",
	"./countryall/153-cuba.svg": "8bc3",
	"./countryall/154-swaziland.svg": "de9e",
	"./countryall/155-israel.svg": "a0e1",
	"./countryall/156-costa-rica.svg": "3adb",
	"./countryall/157-republic-of-the-congo.svg": "0bba",
	"./countryall/158-egypt.svg": "89ad",
	"./countryall/159-cambodia.svg": "8913",
	"./countryall/160-northern-marianas-islands.svg": "156d",
	"./countryall/161-ivory-coast.svg": "0b6e",
	"./countryall/162-germany.svg": "2707",
	"./countryall/163-papua-new-guinea.svg": "9904",
	"./countryall/164-croatia.svg": "2b274",
	"./countryall/165-belgium.svg": "aa81",
	"./countryall/166-morocco.svg": "1b55",
	"./countryall/167-macao.svg": "ffd7",
	"./countryall/168-bulgaria.svg": "71d0",
	"./countryall/169-liberia.svg": "0037",
	"./countryall/170-greece.svg": "3730",
	"./countryall/171-galapagos-islands.svg": "5c9f",
	"./countryall/172-st-lucia.svg": "1f23",
	"./countryall/173-mali.svg": "7aa1",
	"./countryall/174-denmark.svg": "ef3d",
	"./countryall/175-rapa-nui.svg": "b969",
	"./countryall/176-lesotho.svg": "29f9",
	"./countryall/177-colombia.svg": "7e26",
	"./countryall/178-palau.svg": "6add",
	"./countryall/179-ireland.svg": "e0be",
	"./countryall/180-french-polynesia.svg": "b3ce",
	"./countryall/181-trinidad-and-tobago.svg": "fbe0",
	"./countryall/182-niue.svg": "f6e8",
	"./countryall/183-hong-kong.svg": "446b",
	"./countryall/184-sweden.svg": "2591",
	"./countryall/185-haiti.svg": "d222",
	"./countryall/186-dominica.svg": "3556",
	"./countryall/187-vanuatu.svg": "155f",
	"./countryall/188-peru.svg": "2c97",
	"./countryall/189-equatorial-guinea.svg": "5cec",
	"./countryall/190-uzbekistn.svg": "a40d",
	"./countryall/191-tonga.svg": "2792",
	"./countryall/192-philippines.svg": "841d",
	"./countryall/193-norfolk-island.svg": "4036",
	"./countryall/194-malta.svg": "cad6",
	"./countryall/195-france.svg": "b7d0",
	"./countryall/196-tajikistan.svg": "4842",
	"./countryall/197-melilla.svg": "c2f8",
	"./countryall/198-argentina.svg": "298d",
	"./countryall/199-sudan.svg": "87e6",
	"./countryall/200-south-africa.svg": "ebe7",
	"./countryall/201-martinique.svg": "383b",
	"./countryall/202-taiwan.svg": "2dd4",
	"./countryall/203-sahrawi-arab-democratic-republic.svg": "3a05",
	"./countryall/204-guernsey.svg": "7183",
	"./countryall/205-switzerland.svg": "469f9",
	"./countryall/206-rwanda.svg": "79b00",
	"./countryall/207-guam.svg": "3012",
	"./countryall/208-palestine.svg": "47ce",
	"./countryall/209-indonesia.svg": "c967",
	"./countryall/210-grenada.svg": "47b0",
	"./countryall/211-poland.svg": "2f0c",
	"./countryall/212-moldova.svg": "2b71",
	"./countryall/213-gibraltar.svg": "cb9a",
	"./countryall/214-malawi.svg": "8bb8",
	"./countryall/215-falkland-islands.svg": "cd21",
	"./countryall/216-england.svg": "ca4c",
	"./countryall/217-virgin-islands.svg": "9092",
	"./countryall/218-turkey.svg": "5533",
	"./countryall/219-isle-of-man.svg": "fb8f",
	"./countryall/220-vietnam.svg": "abfa",
	"./countryall/221-tuvalu.svg": "c4f8",
	"./countryall/222-niger.svg": "dd15",
	"./countryall/223-turks-and-caicos.svg": "47da",
	"./countryall/224-portugal.svg": "ee8e",
	"./countryall/225-maldives.svg": "d1b0",
	"./countryall/226-united-states.svg": "295a",
	"./countryall/227-senegal.svg": "55dc",
	"./countryall/228-nauru.svg": "252a",
	"./countryall/229-turkmenistan.svg": "7c90",
	"./countryall/230-singapore.svg": "cc94",
	"./countryall/231-libya.svg": "3fb6",
	"./countryall/232-yemen.svg": "3d03",
	"./countryall/233-transnistria.svg": "9b93",
	"./countryall/234-australia.svg": "a2b3",
	"./countryall/235-tokelau.svg": "0961",
	"./countryall/236-republic-of-macedonia.svg": "32ac",
	"./countryall/237-netherlands.svg": "d775",
	"./countryall/238-thailand.svg": "6ca1",
	"./countryall/239-montenegro.svg": "e658",
	"./countryall/240-azores-islands.svg": "987e",
	"./countryall/241-st-vincent-and-the-grenadines.svg": "e7587",
	"./countryall/242-madagascar.svg": "1cae",
	"./countryall/243-canada.svg": "0730",
	"./countryall/244-south-sudan.svg": "be5e",
	"./countryall/245-jersey.svg": "cfe5",
	"./countryall/246-india.svg": "9c3c",
	"./countryall/247-somaliland.svg": "75a6",
	"./countryall/248-russia.svg": "79f4",
	"./countryall/249-democratic-republic-of-congo.svg": "5023",
	"./countryall/250-sint-eustatius.svg": "b5a2",
	"./countryall/251-samoa.svg": "2c28",
	"./countryall/252-mexico.svg": "773c",
	"./countryall/253-seychelles.svg": "74ff",
	"./countryall/254-nato.svg": "296f",
	"./countryall/255-brazil.svg": "b311",
	"./countryall/256-georgia.svg": "b43a",
	"./countryall/257-sardinia.svg": "7f7d",
	"./countryall/258-mongolia.svg": "3e25",
	"./countryall/259-european-union.svg": "a443",
	"./countryall/260-united-kingdom.svg": "b745",
	"./countryall/261-kiribati.svg": "f9cf",
	"./countryall/262-hawaii.svg": "6db9",
	"./ellipsis.png": "76c4",
	"./flag.png": "5904",
	"./header_cart.svg": "3d18",
	"./header_language.svg": "ddf1",
	"./header_mypage.svg": "e0b0",
	"./iSTAY.png": "f354",
	"./ico_add_file.svg": "c0c1",
	"./ico_amenity.png": "cdf6",
	"./ico_arr_down_wh.png": "3b30",
	"./ico_arrow.svg": "92a9",
	"./ico_attach_img.png": "d1ec",
	"./ico_award.svg": "8b70",
	"./ico_back.png": "25a3",
	"./ico_back_white.png": "b4a6",
	"./ico_calendar.svg": "b85e",
	"./ico_calendar_black.png": "9245",
	"./ico_calendar_black.svg": "25ca",
	"./ico_cart.png": "1f47",
	"./ico_cart.svg": "e104",
	"./ico_cart_order.png": "5399",
	"./ico_cart_white.png": "81bb",
	"./ico_checked.svg": "19a7",
	"./ico_checkout_date.svg": "9b01",
	"./ico_checkout_error.svg": "c117",
	"./ico_checkout_front.svg": "09d1",
	"./ico_checkout_pay.svg": "adcb",
	"./ico_checkout_step_1.svg": "0340",
	"./ico_checkout_step_2.svg": "e9be",
	"./ico_checkout_step_3.svg": "856a",
	"./ico_circle.svg": "3a35",
	"./ico_clear.png": "c8e0",
	"./ico_clock.png": "113f",
	"./ico_clock_wh.png": "d84c",
	"./ico_close.svg": "a5c8",
	"./ico_close_black.svg": "02c1",
	"./ico_complete.svg": "78e7",
	"./ico_copy.svg": "d023",
	"./ico_copy_grey.svg": "aad8",
	"./ico_coupon.png": "a2aa",
	"./ico_credit-card.png": "9f08",
	"./ico_destination_pin.png": "d20a",
	"./ico_directory.svg": "4f5c",
	"./ico_disabled_on.png": "6306",
	"./ico_documents.svg": "57d9",
	"./ico_door.png": "fa6f",
	"./ico_download.svg": "ea13",
	"./ico_external.svg": "5038a",
	"./ico_fail.svg": "69b3",
	"./ico_fan.png": "e234",
	"./ico_finger.png": "f718",
	"./ico_folder.svg": "04ff",
	"./ico_google_translate.png": "f688",
	"./ico_grid.png": "e8df",
	"./ico_heart.svg": "675e",
	"./ico_home.svg": "d150",
	"./ico_home_wh.png": "62bc",
	"./ico_hotel.png": "b957",
	"./ico_invoice.png": "4d56",
	"./ico_is_destination.png": "bb50",
	"./ico_is_destination_bk.png": "4aa0",
	"./ico_like.svg": "ba63",
	"./ico_like_active.svg": "9433",
	"./ico_link.svg": "ff0c",
	"./ico_list.png": "8573",
	"./ico_localinfo.png": "4ae7",
	"./ico_localinfo_star.png": "842f",
	"./ico_location.png": "4e26",
	"./ico_location_pin.png": "e227",
	"./ico_lock.png": "9d16",
	"./ico_logout.png": "0a06",
	"./ico_member.png": "41d1",
	"./ico_minus.svg": "fb0b",
	"./ico_mobile.png": "ec99",
	"./ico_move.svg": "6da0",
	"./ico_mypage_cart.png": "95d9",
	"./ico_mypage_coupon.png": "eae0",
	"./ico_mypage_mobility.png": "51f7",
	"./ico_mypage_order.png": "292c",
	"./ico_mypage_payment.png": "9098",
	"./ico_mypage_reservation.png": "bb1f",
	"./ico_no_destination.png": "406b",
	"./ico_no_destination_bk.png": "c4ce",
	"./ico_order.png": "5f65",
	"./ico_paid.png": "6370",
	"./ico_payment.png": "a949",
	"./ico_payment_default.png": "af19",
	"./ico_payment_disabled.png": "47dc",
	"./ico_pencil.svg": "306a",
	"./ico_plane.png": "4002",
	"./ico_plus.svg": "065e",
	"./ico_power.png": "72af",
	"./ico_preview_m.png": "bac3",
	"./ico_preview_t.png": "1cdb",
	"./ico_preview_w.png": "1e21",
	"./ico_product_default.svg": "7210",
	"./ico_qrcode_svg.svg": "f49b",
	"./ico_question.png": "a3d1",
	"./ico_rateStar.png": "b936",
	"./ico_reload.svg": "8b56",
	"./ico_reload_wh.png": "5d2e",
	"./ico_remove.svg": "abac",
	"./ico_reservation.png": "1a62",
	"./ico_resize.png": "8d478",
	"./ico_reverse.svg": "abd0",
	"./ico_roomcharge.png": "e0cd",
	"./ico_roomcharge_default.png": "48fd",
	"./ico_roomcharge_disabled.png": "aed0",
	"./ico_search.svg": "434f",
	"./ico_send.png": "849f",
	"./ico_send_video.png": "c8bf",
	"./ico_setting.svg": "f37b",
	"./ico_setting_white.svg": "2f6b",
	"./ico_share.svg": "2a04",
	"./ico_smile.svg": "de36",
	"./ico_speaker.png": "0865",
	"./ico_square.svg": "6400",
	"./ico_star.svg": "f5fd",
	"./ico_start_pin.png": "471a",
	"./ico_tablet.png": "d07d",
	"./ico_talk.svg": "7df8",
	"./ico_talk_bot.png": "b9eb",
	"./ico_talk_info.png": "e5d5",
	"./ico_talk_user.png": "9903",
	"./ico_talk_user_1.png": "2326",
	"./ico_talk_user_2.png": "acf0",
	"./ico_tel.png": "aab8",
	"./ico_terrible_simple.svg": "5a09",
	"./ico_touchmove_horizontal.png": "0bb9",
	"./ico_translate.svg": "79b0e",
	"./ico_tv.png": "39fc",
	"./ico_unRateStar.png": "2347",
	"./ico_undo.png": "3162",
	"./ico_unlock.png": "148c",
	"./ico_unlock_wh.png": "51b5",
	"./ico_user.svg": "6582",
	"./ico_video_play.png": "e781",
	"./ico_voucher.svg": "124d",
	"./ico_warning.svg": "eaaa",
	"./ico_window.png": "7df3",
	"./ico_zoomin.png": "9af6",
	"./ico_zoomout.png": "7b8b",
	"./img_product_default.png": "6b26",
	"./img_qr_fail.png": "ff09",
	"./img_qr_loading.png": "5161",
	"./img_user_default.svg": "193d",
	"./istay-orange-text.png": "117e",
	"./istay-orange.png": "1fb0",
	"./istay-white-text.png": "99b1",
	"./istay-white.png": "eff5",
	"./key-round.png": "a364",
	"./languages.png": "4b90",
	"./loading.svg": "333e",
	"./localType/bar.png": "c969",
	"./localType/cafe.png": "c745",
	"./localType/localInfo.png": "ac7e",
	"./localType/park.png": "37a4",
	"./localType/restaurant.png": "ba00",
	"./localType/roundArrow.png": "f1ec",
	"./localType/tourist_attraction.png": "0b51",
	"./localinfo.png": "f842",
	"./localinfo_nodata.png": "b43e",
	"./location_hotel.svg": "b94b",
	"./location_place.svg": "746d",
	"./lock.png": "c2b0",
	"./logo_facebook.svg": "4139",
	"./logo_flickr.svg": "ef69",
	"./logo_google_translate.png": "6d49",
	"./logo_instagram.svg": "db71",
	"./minus_wh.png": "a19b",
	"./mobile_check.png": "e8c8",
	"./mobile_warn.png": "d665",
	"./passed.png": "b146",
	"./plus_wh.png": "6ae1",
	"./product_stkr_best.png": "d0b5",
	"./product_stkr_best.svg": "8e65",
	"./product_stkr_event.png": "c149",
	"./product_stkr_event.svg": "fbdd",
	"./product_stkr_heritage.png": "6a84",
	"./product_stkr_promotion.png": "2968",
	"./product_stkr_promotion.svg": "b6b1",
	"./product_stkr_sale.png": "9b9e",
	"./product_stkr_sale.svg": "ff92",
	"./product_stkr_signature.png": "2add",
	"./product_stkr_signature.svg": "5f46a",
	"./question.png": "7d26",
	"./rate_circle.svg": "d497",
	"./rate_heart.svg": "4363",
	"./rate_smile.svg": "ea07",
	"./rate_square.svg": "58fc",
	"./rate_star.svg": "b66d",
	"./refresh-ccw.png": "08b9",
	"./refresh-cw.png": "3973",
	"./required.png": "b213",
	"./right_arrow.png": "6fbb",
	"./roomcontroller/DigitalNumbers-Regular.woff": "932d",
	"./roomcontroller/ico_curtain_1.png": "1161",
	"./roomcontroller/ico_curtain_2.png": "26b4",
	"./roomcontroller/ico_curtain_3.png": "7c2a",
	"./roomcontroller/ico_curtain_4.png": "0a17",
	"./roomcontroller/ico_default.png": "6b88",
	"./roomcontroller/ico_dm_1.png": "34b2",
	"./roomcontroller/ico_dm_2.png": "fca2",
	"./roomcontroller/ico_door_1.png": "be15",
	"./roomcontroller/ico_door_2.png": "8b7c",
	"./roomcontroller/ico_fcu_1.png": "47d1",
	"./roomcontroller/ico_fcu_2.png": "660e",
	"./roomcontroller/ico_fcu_3.png": "63db",
	"./roomcontroller/ico_fcu_4.png": "5292",
	"./roomcontroller/ico_fcu_5.png": "ba5c",
	"./roomcontroller/ico_light_1.png": "da87",
	"./roomcontroller/ico_light_2.png": "cb8e",
	"./roomcontroller/ico_light_3.png": "7977",
	"./roomcontroller/ico_light_4.png": "c064",
	"./roomcontroller/ico_light_5.png": "f164",
	"./skin_active_menu_type1.png": "b4a2",
	"./skin_active_menu_type_block.png": "f37d",
	"./skin_active_menu_type_default.png": "1c43",
	"./sns_facebook.png": "12c5",
	"./sns_flickr.png": "ddd1",
	"./sns_instagram.png": "460b",
	"./sns_tripadvisor.png": "0828",
	"./sns_twitter.png": "17e8",
	"./sns_youtube.png": "3cf7",
	"./ticket.png": "493e",
	"./tvcontrol.png": "3486",
	"./tvcontrol_nodata.png": "5fe8",
	"./tvcontroller/ico_brightness+.png": "3707",
	"./tvcontroller/ico_brightness-.png": "c21e",
	"./tvcontroller/ico_fast_forward.png": "c1c2",
	"./tvcontroller/ico_netflix.png": "3f0f",
	"./tvcontroller/ico_next.png": "cf1f",
	"./tvcontroller/ico_pause.png": "8364",
	"./tvcontroller/ico_play.png": "4827",
	"./tvcontroller/ico_previous.png": "3a6d",
	"./tvcontroller/ico_rewind.png": "b5f8",
	"./tvcontroller/ico_stop.png": "57aa",
	"./warn.png": "c7ac",
	"./x.png": "5610"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";